module.exports = __webpack_public_path__ + "static/media/UI-Click.c62270b0.wav";